
export const converteTimeToMonth = (time: string) => {
    const date = new Date(time)
    return date.toLocaleString('default', {month: '2-digit', timeZone: 'UTC'}) +"/"+date.toLocaleString('default', {year: '2-digit', timeZone: 'UTC'})
}

export const converteTimeToDay = (time: string) => {
    const date = new Date(time)
    return date.toLocaleString('default', {weekday: 'long',  timeZone: 'UTC'}).split('')[0].toUpperCase()+" "+date.toLocaleString('default', {day: '2-digit',  timeZone: 'UTC'})+"/"+date.toLocaleString('default', {month: '2-digit',  timeZone: 'UTC'}) +"/"+date.toLocaleString('default', {year: '2-digit',  timeZone: 'UTC'})
}

export const converteTimeToHour = (time: string) => {
    const date = new Date(time)
    return converteTimeToDay(time)+' '+date.getUTCHours()+"h"
}

export const converteTimeTo15Minutes = (time: string) => {
    const date = new Date(time)
    const minutes = date.getUTCMinutes()
    const hours = date.getUTCHours()
    return converteTimeToDay(time)+' '+hours.toString().padStart(2, '0')+"h"+minutes.toString().padStart(2, '0')
}

export const converteTimeToYear = (time: string) => {
    const date = new Date(time)
    return date.toLocaleString('default', {year: 'numeric',  timeZone: 'UTC'})
}

export const converteTimeToString = (time: string, type: 'mo'|'d'|'h'|'y'|'15m') => {
    switch (type) {
        case 'mo':
            return converteTimeToMonth(time)
        case 'd':
            return converteTimeToDay(time)
        case 'h':
            return converteTimeToHour(time)
        case 'y':
            return converteTimeToYear(time)
        case '15m':
            return converteTimeTo15Minutes(time)
        default:
            return ''
    }
}

export const calculateDifferenceDate = (date1: Date, date2: Date, type: 'm' | 'h' | 'd' | 'mo'): number => {
    const diffInMs = Math.abs(date2.getTime() - date1.getTime());

    switch (type) {
        case 'm':
            return diffInMs / (1000 * 60); // Convertir les millisecondes en minutes
        case 'h':
            return diffInMs / (1000 * 60 * 60); // Convertir les millisecondes en heures
        case 'd':
            return diffInMs / (1000 * 60 * 60 * 24); // Convertir les millisecondes en jours
        case 'mo':
            const year1 = date1.getUTCFullYear();
            const year2 = date2.getUTCFullYear();
            const month1 = date1.getUTCMonth();
            const month2 = date2.getUTCMonth();
            return (year2 - year1) * 12 + (month2 - month1); // Calculer la différence en mois
        default:
            throw new Error('Type non supporté');
    }
}


